'use strict';

const RefResolver = require('json-ref-lite');
//const aaaa = require.context('../translations/legal', true);

let getJsonByLang = (lang) => {
    //dd(require);
    //dd(require.extensions);
    //require.extensions['.html'] = () => {};
    //dd(aaaa(`./${lang}.html`));
    //dd(aaaa);
    //dd(require(`../translations/${lang}.json`));
    let dicc = RefResolver.resolve(require(`../translations/${lang}.json`));
    //dd(dicc);
    //dd(`../translations/legal/${lang}.html`);
    //dd(require(`../translations/legal/${lang}.html`));
    //dicc.configInfoPanel.description = require(`../translations/legal/${lang}.html`);
    return dicc;
};

class Translations {
    constructor(defaultLang, lang) {
        let defaultTranslation = getJsonByLang(defaultLang);

        if (defaultLang !== lang) {
            try {
                this.translation = { ...defaultTranslation, ...getJsonByLang(lang) };
            } catch {
                this.translation = defaultTranslation;
            }
        } else this.translation = defaultTranslation;
    }
}

export default Translations;

//import Vue from 'vue';
//import VueI18n from 'vue-i18n';
//Vue.use(VueI18n);

// let aaa = import(
//     /* webpackInclude: /\.json$/ */
//     /* webpackExclude: /\.noimport\.json$/ */
//     /* webpackChunkName: "my-chunk-name" */
//     /* webpackMode: "lazy" */
//     /* webpackPrefetch: true */
//     /* webpackPreload: true */
//     /^\.\.\/translations\/.*\.json$/
// );
// dd(aaa);

// var languages = {};
// const translations = require.context('../translations/', true, /^(.*)\.json$/);
// dd(translations);
// dd(translations.keys());

// const translations2 = require.context('../translations/', false, /^(.*)\.json$/);
// dd(translations2);
// dd(translations2.keys());
// dd(translations2());

// translations
//     .keys()
//     .map(translations)
//     .forEach((element) => {
//         dd(element);
//         dd(element.default);
//         dd(element.default.name);
//         languages[element.default.name] = element.default;
//     });
